import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormattedNumberInput from '~/components/forms/FormattedNumberInput';
import { cn } from '~/helpers/utils';

type AmountFieldProps = {
  name: string;
  label?: string;
  labelClass?: string;
  description?: string;
  descriptionClass?: string;
  placeholder?: string;
};

const AmountField: React.FC<AmountFieldProps> = ({
  name,
  label,
  labelClass,
  description,
  descriptionClass,
  placeholder,
}) => {
  const { control } = useFormContext();
  
  const inputId: string = `field-${name}`;
  
  return (
    <div className="form-control">
      {label && (
        <label htmlFor={inputId} className={cn('form-label', labelClass)}>
          {label}
        </label>
      )}
      {description && (
        <p className={descriptionClass}>{description}</p>
      )}
      <Controller
        name={name}
        control={control}
        render= {({ field, fieldState }) => (
          <>
            <FormattedNumberInput
              {...field}
              id={inputId}
              placeholder={placeholder}
              hasError={!!fieldState.error}
            />
            {fieldState.error && (
              <span className="text-sm text-tomato-600">{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default AmountField;